<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Tax Libraries
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Setting Dashboard</el-button>
            </div>
          </div>
          <el-tabs v-model="activeTab" @tab-click="handleClickTabs">
            <el-tab-pane name="projectTaxes" :label="$t('settings_accountThink_taxTypes_taxes')">
              <el-table
                max-height="600"
                :data="tableData"
                :empty-text="$t('general_noData')"
                style="width: 100%">
                <el-table-column align="center" label="ID" width="100">
                  <template slot-scope="scope">
                    <div v-html="scope.row.id"></div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Code" width="120">
                  <template slot-scope="scope">
                    <div v-html="scope.row.code"></div>
                  </template>
                </el-table-column>
                <el-table-column label="Name">
                  <template slot-scope="scope">
                    <div v-html="scope.row.name"></div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Rate" width="100">
                  <template slot-scope="scope">
                    <div v-html="scope.row.rate[0].rate"></div>
                  </template>
                </el-table-column>
                <el-table-column label="Description" width="200">
                  <template slot-scope="scope">
                    <div v-html="scope.row.description"></div>
                  </template>
                </el-table-column>
                <el-table-column label="Type">
                  <template slot-scope="scope">
                    <div v-html="scope.row.type.name"></div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="No Tax">
                  <template slot-scope="scope">
                    <div v-if="scope.row.taxAccount">
                      <!-- <el-checkbox
                          disabled
                          v-model="scope.row.taxAccount.noTax"
                          @change="changeNoTax($event, scope.row)">
                      </el-checkbox> -->
                      <div v-if="scope.row.taxAccount.noTax">
                        <i class="el-icon-success"></i>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="No Tax S/P">
                  <template slot-scope="scope">
                    <div v-if="scope.row.taxAccount">
                      <!-- <el-checkbox
                          disabled
                          v-model="scope.row.taxAccount.noTax"
                          @change="changeNoTax($event, scope.row)">
                      </el-checkbox> -->
                      <div v-if="scope.row.taxAccount.noTaxSP">
                        <i class="el-icon-success"></i>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Zero Tax">
                  <template slot-scope="scope">
                    <div v-if="scope.row.taxAccount">
                        <!-- <el-checkbox
                            disabled
                            v-model="scope.row.taxAccount.zeroTax"
                            @change="changeZeroTax($event, scope.row)">
                        </el-checkbox> -->
                        <div v-if="scope.row.taxAccount.zeroTax">
                          <i class="el-icon-success"></i>
                        </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Tax Exempt">
                  <template slot-scope="scope">
                    <div v-if="scope.row.taxAccount">
                      <!-- <el-checkbox
                          disabled
                          v-model="scope.row.taxAccount.exemptTax"
                          @change="changeTaxExempt($event, scope.row)">
                      </el-checkbox> -->
                      <div v-if="scope.row.taxAccount.exemptTax">
                        <i class="el-icon-success"></i>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Use Tax">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.created" @change="changeCheckbox(scope.row.id, 'Sales', scope.row.created, scope.row)"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Created On" width="120">
                  <template slot-scope="scope">
                    {{ moment(scope.row.createdAt).format("D MMM YY") }}
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Updated On" width="120">
                  <template slot-scope="scope">
                    {{ moment(scope.row.updatedAt).format("D MMM YY") }}
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane name="withholdingTaxes" :label="$t('settings_accountThink_taxTypes_withholdingTaxes')">
              <el-table
                max-height="600"
                :data="tableData"
                :empty-text="$t('general_noData')"
                style="width: 100%">
                <el-table-column align="center" label="ID" width="100">
                  <template slot-scope="scope">
                    <div v-html="scope.row.id"></div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Code" width="120">
                  <template slot-scope="scope">
                    <div v-html="scope.row.code"></div>
                  </template>
                </el-table-column>
                <el-table-column label="Name">
                  <template slot-scope="scope">
                    <div v-html="scope.row.name"></div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Rate" width="100">
                  <template slot-scope="scope">
                    <div v-html="scope.row.rate[0] ? scope.row.rate[0].rate : null"></div>
                  </template>
                </el-table-column>
                <el-table-column label="Remark" width="120">
                  <template slot-scope="scope">
                    <div v-if="scope.row.remark" v-html="scope.row.remark.name"></div>
                  </template>
                </el-table-column>
                <el-table-column label="Description" width="200">
                  <template slot-scope="scope">
                    <div v-html="scope.row.description"></div>
                  </template>
                </el-table-column>
                <el-table-column label="Type">
                  <template slot-scope="scope">
                    <div v-html="scope.row.type.name"></div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Use Tax">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.created" @change="changeCheckbox(scope.row.id, 'WithHolding', scope.row.created, scope.row)"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Created On" width="120">
                  <template slot-scope="scope">
                    {{ moment(scope.row.createdAt).format("D MMM YY") }}
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Updated On" width="120">
                  <template slot-scope="scope">
                    {{ moment(scope.row.updatedAt).format("D MMM YY") }}
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "TaxLibraries",
  components: {
    SweetModal,
  },
  data() {
    return {
      activeTab: 'projectTaxes',
      tableData: [],
      moment:moment,
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
  },
  beforeMount() {
    this.loadList()
  },
  methods: {
    loadList(){
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyLayout/getData?companyId=${this.$route.query.companyId}`)
        .then(response => {
          let countryId = response.data.companyAccountingAndBusinessInfo.countryForTaxRepId

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/tax/get?companyId=${this.$route.query.companyId}&countryId=${countryId}&taxTopType=${this.activeTab === 'projectTaxes' ? 'sale' : 'withholding'}`)
            .then(response => {
              this.tableData = response.data.result
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        })
        .catch(error => {
          console.log('An error occurred:', error);
        });
    },
    async changeNoTax(val, row) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        this.loadList()
        await axios.get(`/api/v1/account/updateNoTax?accountId=${row.taxAccount.id}`)
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async changeZeroTax(val, row) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        this.loadList()
        await axios.get(`/api/v1/account/updateZeroTax?accountId=${row.taxAccount.id}`)
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async changeTaxExempt(val, row) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        this.loadList()
        await axios.get(`/api/v1/account/updateExemptTax?accountId=${row.taxAccount.id}`)
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    changeCheckbox(taxId, taxTopType, created, row) {
      if (created) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/tax-account/create`, {
            companyId: +this.$route.query.companyId,
            currencyId: this.companyLayout.currency.id,
            taxId: taxId,
            taxTopType: taxTopType
          })
          .then(response => {
            this.loadList()
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      } else {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/account/delete?companyId=${this.$route.query.companyId}&accountId=${row.taxAccount.id}`)
          .then(response => {
            this.loadList()
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            this.loadList()
            loader.hide()
          });
      }
    },
    handleClickTabs(tab){
      this.loadList()
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
